import { createContext, useContext } from "react";

import {
  PrimaryPaletteKey,
  DEFAULT_PRIMARY_PALETTE
} from "./tokens/primaryPalettes";

export type PrimaryPaletteContextValue = {
  primaryPalette: PrimaryPaletteKey;
  setPrimaryPalette: (next: PrimaryPaletteKey) => void;
};

/**
 * The selected primary palette. Owned by `ThemeCustomization` (the app's theme
 * root) rather than a new global provider — it is the component that already
 * builds the theme from this value.
 */
export const PrimaryPaletteContext = createContext<PrimaryPaletteContextValue>({
  primaryPalette: DEFAULT_PRIMARY_PALETTE,
  setPrimaryPalette: () => undefined
});

export const usePrimaryPalette = () => useContext(PrimaryPaletteContext);
